import { connect, Dispatch } from 'react-redux';

import { Action } from '../../actions';
import { changeProductCell, fetchChangeProduct } from '../../actions/products';
import {
    ProductDescriptionCell,
    ProductDescriptionCellProps
} from '../../components/ProductDescriptionCell/ProductDescriptionCell';
import { ProductsListCellItem } from '../../typings/products';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

type StateProps = TStateProps<ProductDescriptionCellProps>;
type DispatchProps = TDispatchProps<ProductDescriptionCellProps>;

const mapStateToProps = (
    state: State,
    ownProps: ProductsListCellItem
): StateProps => {
    const {
        products: { pageStatus },
        grid: { isGridScrolling },
        commonData: { accessRights }
    } = state;

    return {
        product: ownProps,
        pageStatus,
        isGridScrolling,
        access: Boolean(accessRights.canManageInternalAdAccessRights)
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        onChangeProductDescription: (product: ProductsListCellItem) =>
            dispatch(changeProductCell(product)),
        onSaveProductDescription: (product: ProductsListCellItem) =>
            dispatch(fetchChangeProduct(product))
    };
};

export const ProductDescriptionCellContainer = connect<
    StateProps,
    DispatchProps
>(
    mapStateToProps,
    mapDispatchToProps
)(ProductDescriptionCell);
